import { TextHighlighter } from 'pdfjs-dist/legacy/web/pdf_viewer';

/**
 * Suppresses the default rendering of {@link TextHighlighter}.
 * The default behaviour is to modify the text layer, whereas matches are rendered on the custom
 * enhancements layer instead. Instead, dispatches “matchesreset” and ”matchesupdated” events to be
 * handled by reader-enhancements.
 */
export default class CustomTextHighlighter extends TextHighlighter {
  /**
   * Start listening for events to update the highlighter and check if there are
   * any current matches that need be highlighted.
   */
  enable() {
    if (!this._onUpdateTextLayerMatches) {
      this._onUpdateTextLayerMatches = (evt) => {
        if (evt.pageIndex === this.pageIdx) {
          this._updateMatches();
        } else if (evt.pageIndex === -1) {
          this.eventBus.dispatch('matchesreset');
        }
      };

      this.eventBus._on('updatetextlayermatches', this._onUpdateTextLayerMatches);
    }

    super.enable();
  }

  _renderMatches(matches) {
    const { matchIdx, pageIdx } = this.findController.selected;
    const selectedMatchIndex = this.pageIdx === pageIdx ? matchIdx : null;

    this.eventBus.dispatch('matchesupdated', {
      pageIndex: this.pageIdx,
      matches,
      selectedMatchIndex,
      textContent: this.textContentItemsStr,
    });
  }

  _updateMatches() {
    if (!this.enabled) {
      return;
    }
    const { findController, pageIdx } = this;

    if (!findController?.highlightMatches) {
      return;
    }
    // Convert the matches on the `findController` into the match format
    // used for the textLayer.
    const pageMatches = findController.pageMatches[pageIdx] || null;
    const pageMatchesLength = findController.pageMatchesLength[pageIdx] || null;

    this.matches = this._convertMatches(pageMatches, pageMatchesLength);
    this._renderMatches(this.matches);
  }
}
